import { HttpHandler } from 'msw'

import { sites } from './sites'

export const park: HttpHandler[] = [...sites]
